/** 배포되는 모드 정의(JSON) — 운영 콘솔이 교체할 수 있는 데이터(SR-CAT-02). 여기서는 저장소 기본값을 싣는다 */
import obstacle from "../defs/obstacle-course.v2.json" with { type: "json" };
import galleryJson from "../defs/gallery.v1.json" with { type: "json" };
import pushoutJson from "../defs/pushout-ring.v1.json" with { type: "json" };
import sandboxJson from "../defs/sandbox.v1.json" with { type: "json" };
import relayJson from "../defs/relay-machine.v1.json" with { type: "json" };
import carryJson from "../defs/carry-together.v1.json" with { type: "json" };
import stageJson from "../defs/machine-stage.v8.json" with { type: "json" };
import type { ModeDefinitionV1 } from "./types";

export const obstacleCourse = obstacle as unknown as ModeDefinitionV1;
/** 전시관(SR-MODE-02 · S4) — 받침대 30 · 작동 60초 · 동시 6 · 기계끼리 충돌 없음 */
export const gallery = galleryJson as unknown as ModeDefinitionV1;
/** P2-S3 룸 모드 — 스모(SR-MODE-04) · 협동 운반(SR-MODE-05) */
export const pushoutRing = pushoutJson as unknown as ModeDefinitionV1;
export const carryTogether = carryJson as unknown as ModeDefinitionV1;
/** P2-S5 자유 놀이터(SR-MODE-06) */
export const sandbox = sandboxJson as unknown as ModeDefinitionV1;
/** P3-S1 릴레이 기계(SR-MODE-07 · DEC-003) — PH3 · 제어 평면 플래그 뒤 */
export const relayMachine = relayJson as unknown as ModeDefinitionV1;
/** 기구 무대(PICNIC-SB-FIELD-001 §6.1 · 2026-10-06) — 정적 기계를 받침대에 묶고 관절로 별 3단계(13차시) */
export const machineStage = stageJson as unknown as ModeDefinitionV1;
export const MODE_DEFS: Readonly<Record<string, ModeDefinitionV1>> = {
  [obstacleCourse.id]: obstacleCourse,
  [gallery.id]: gallery,
  [pushoutRing.id]: pushoutRing,
  [carryTogether.id]: carryTogether,
  [sandbox.id]: sandbox,
  [relayMachine.id]: relayMachine,
  [machineStage.id]: machineStage,
};
